// Acquire an access token for the Ops Hub API, usable OUTSIDE React (the api client
// and the anthropic-key fetch are plain modules, not components). Reads the account
// straight off the shared msalInstance so non-React code can call it.
//
// SILENT ONLY, by design. This runs from data fetches — up to seven in parallel on
// load. It must NEVER start an interactive redirect: concurrent redirects wedge
// MSAL's interaction_in_progress state, corrupt the session, and then block the
// sign-in button entirely. The API token is instead obtained at sign-in (the login
// request includes the API scope; see AuthProvider), so acquireTokenSilent resolves
// it straight from cache here. On any failure we fail soft (return null → the call
// gets a 401 and the app shows the sign-in screen), never throw, never redirect.
import { msalInstance, apiTokenRequest } from "./msalConfig.js";

export async function getApiToken() {
  const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
  if (!account) return null; // not signed in yet — caller sends no Authorization header
  try {
    const res = await msalInstance.acquireTokenSilent({ ...apiTokenRequest, account });
    return res.accessToken;
  } catch (e) {
    console.warn("API token acquisition failed:", e?.errorCode || e?.message || e);
    return null;
  }
}

// Build headers with the bearer token attached (merged over any provided headers).
// The token goes in a CUSTOM header, not Authorization: Azure Static Web Apps
// overwrites the standard Authorization header on requests to managed functions
// (documented platform behavior), so the function never sees it. X-Ops-Auth passes
// through untouched. The server (api/src/auth.js) reads X-Ops-Auth first.
export async function authHeaders(extra = {}) {
  const token = await getApiToken();
  return token ? { ...extra, "X-Ops-Auth": `Bearer ${token}` } : { ...extra };
}
